import { LOGIN_SUCCESS, LOGOUT } from "../actions/types"

const initialState = {
    token: '',
    isLoggedIn: false,
}

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                ...payload,
                isLoggedIn: true,
            };
        case LOGOUT:
            localStorage.removeItem('tokenData');
            return {
                ...state,
                token: '',
                isLoggedIn: false,
            };
        default:
            return state
    }
}